export component accordion(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="6"
			width="18"
			height="3"
			rx="1"
			fill="currentColor"
			opacity="0.3"
		/>
		<rect
			x="3"
			y="10"
			width="18"
			height="3"
			rx="1"
			fill="currentColor"
			opacity="0.6"
		/>
		<rect x="3" y="14" width="18" height="3" rx="1" fill="currentColor" />
		<path
			d="M18 7.5L16 9.5L18 11.5"
			stroke="currentColor"
			strokeWidth="1.5"
			fill="none"
		/>
	</svg>
}

export component slider(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="12"
			r="9"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="12" cy="12" r="2" fill="currentColor" />
		<line
			x1="12"
			y1="12"
			x2="12"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<circle cx="12" cy="6" r="2" fill="currentColor" />
	</svg>
}

export component user(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle cx="12" cy="8" r="4" fill="currentColor" opacity="0.6" />
		<path
			d="M6 20c0-4 2.7-6 6-6s6 2 6 6"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component carousel(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="2"
			y="6"
			width="4"
			height="12"
			rx="1"
			fill="currentColor"
			opacity="0.3"
		/>
		<rect x="7" y="4" width="10" height="16" rx="2" fill="currentColor" />
		<rect
			x="18"
			y="6"
			width="4"
			height="12"
			rx="1"
			fill="currentColor"
			opacity="0.3"
		/>
	</svg>
}

export component checkbox(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="4"
			y="4"
			width="16"
			height="16"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M8 12l3 3 5-6"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component clipboard(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="8"
			y="2"
			width="8"
			height="4"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component collapsible(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect x="3" y="6" width="18" height="4" rx="1" fill="currentColor" />
		<path d="M7 14h10" stroke="currentColor" strokeWidth="2" />
		<path d="M7 17h6" stroke="currentColor" strokeWidth="2" opacity="0.6" />
		<path
			d="M17 15l2 2-2 2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component color(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="12"
			r="9"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M12 3v18" stroke="currentColor" strokeWidth="2" />
		<path d="M3 12h18" stroke="currentColor" strokeWidth="2" />
		<circle cx="12" cy="12" r="3" fill="currentColor" />
	</svg>
}

export component combobox(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="6"
			width="18"
			height="12"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M7 10h6" stroke="currentColor" strokeWidth="2" />
		<path
			d="M17 10l2 2-2 2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component calendar(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="4"
			width="18"
			height="18"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<line
			x1="16"
			y1="2"
			x2="16"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="8"
			y1="2"
			x2="8"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="3"
			y1="10"
			x2="21"
			y2="10"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component dialog(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="1"
			y="1"
			width="22"
			height="22"
			rx="1"
			fill="currentColor"
			opacity="0.1"
		/>
		<rect
			x="5"
			y="5"
			width="14"
			height="14"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="currentColor"
			fillOpacity="0.05"
		/>
		<line
			x1="8"
			y1="9"
			x2="16"
			y2="9"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<line
			x1="8"
			y1="12"
			x2="14"
			y2="12"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<circle cx="17" cy="7" r="1" fill="currentColor" />
	</svg>
}

export component edit(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<path
			d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M15 5l4 4" stroke="currentColor" strokeWidth="2" />
	</svg>
}

export component upload(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<path
			d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<polyline
			points="7,10 12,5 17,10"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<line
			x1="12"
			y1="5"
			x2="12"
			y2="15"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component panel(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="3"
			width="18"
			height="18"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M9 9h6v6H9V9z" fill="currentColor" opacity="0.6" />
	</svg>
}

export component card(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="1"
			y="5"
			width="22"
			height="14"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<line
			x1="1"
			y1="10"
			x2="23"
			y2="10"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component list(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<line
			x1="8"
			y1="6"
			x2="21"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="8"
			y1="12"
			x2="21"
			y2="12"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="8"
			y1="18"
			x2="21"
			y2="18"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="3"
			y1="6"
			x2="3.01"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="3"
			y1="12"
			x2="3.01"
			y2="12"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="3"
			y1="18"
			x2="3.01"
			y2="18"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component menu(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<line
			x1="4"
			y1="12"
			x2="20"
			y2="12"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="4"
			y1="6"
			x2="20"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="4"
			y1="18"
			x2="20"
			y2="18"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component context(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle cx="12" cy="12" r="1" fill="currentColor" />
		<circle cx="12" cy="5" r="1" fill="currentColor" />
		<circle cx="12" cy="19" r="1" fill="currentColor" />
	</svg>
}

export component nested(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<line
			x1="4"
			y1="9"
			x2="20"
			y2="9"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="4"
			y1="15"
			x2="20"
			y2="15"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="10"
			y1="3"
			x2="8"
			y2="21"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="16"
			y1="3"
			x2="14"
			y2="21"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component number(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="4"
			y="6"
			width="16"
			height="12"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M10 10l4 4m0-4l-4 4" stroke="currentColor" strokeWidth="2" />
	</svg>
}

export component pagination(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle cx="5" cy="12" r="2" fill="currentColor" />
		<circle cx="12" cy="12" r="2" fill="currentColor" opacity="0.6" />
		<circle cx="19" cy="12" r="2" fill="currentColor" opacity="0.3" />
	</svg>
}

export component password(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="11"
			width="18"
			height="10"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M7 11V7a5 5 0 0 1 10 0v4"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="12" cy="16" r="1" fill="currentColor" />
	</svg>
}

export component pin(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="5"
			y="6"
			width="3"
			height="6"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="8.5"
			y="6"
			width="3"
			height="6"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="12"
			y="6"
			width="3"
			height="6"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="15.5"
			y="6"
			width="3"
			height="6"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component popover(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<path
			d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-5l-5 4v-4H5a2 2 0 0 1-2-2V6z"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component presence(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="12"
			r="10"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="12" cy="12" r="3" fill="currentColor" />
	</svg>
}

export component progress(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="2"
			y="10"
			width="20"
			height="4"
			rx="2"
			fill="currentColor"
			opacity="0.3"
		/>
		<rect x="2" y="10" width="12" height="4" rx="2" fill="currentColor" />
	</svg>
}

export component circle(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="12"
			r="10"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M12 2a10 10 0 0 1 7.07 17.07"
			stroke="currentColor"
			strokeWidth="3"
		/>
	</svg>
}

export component qr(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="3"
			width="7"
			height="7"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="14"
			y="3"
			width="7"
			height="7"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="3"
			y="14"
			width="7"
			height="7"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="14"
			y="14"
			width="7"
			height="7"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect x="5" y="5" width="3" height="3" fill="currentColor" />
		<rect x="16" y="5" width="3" height="3" fill="currentColor" />
		<rect x="5" y="16" width="3" height="3" fill="currentColor" />
		<rect x="16" y="16" width="3" height="3" fill="currentColor" />
	</svg>
}

export component radio(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="12"
			r="10"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="12" cy="12" r="4" fill="currentColor" />
	</svg>
}

export component range(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<line
			x1="4"
			y1="12"
			x2="20"
			y2="12"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<circle cx="8" cy="12" r="2" fill="currentColor" />
		<circle cx="16" cy="12" r="2" fill="currentColor" />
	</svg>
}

export component star(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<polygon
			points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
			fill="currentColor"
		/>
	</svg>
}

export component scroll(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="5"
			width="18"
			height="14"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect x="20" y="8" width="2" height="8" rx="1" fill="currentColor" />
	</svg>
}

export component segment(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect x="3" y="8" width="6" height="8" rx="2" fill="currentColor" />
		<rect
			x="9"
			y="8"
			width="6"
			height="8"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="15"
			y="8"
			width="6"
			height="8"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component select(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="4"
			y="8"
			width="16"
			height="8"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M16 12l4-4-4-4"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component signature(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<path
			d="M3 17c3-1 7-3 11-3s8 2 11 3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M3 12c3-1 7-3 11-3s8 2 11 3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
			opacity="0.6"
		/>
		<path
			d="M3 7c3-1 7-3 11-3s8 2 11 3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
			opacity="0.3"
		/>
	</svg>
}

export component split(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="3"
			y="6"
			width="18"
			height="12"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<line
			x1="12"
			y1="6"
			x2="12"
			y2="18"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component steps(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle cx="6" cy="12" r="3" fill="currentColor" />
		<circle
			cx="12"
			cy="12"
			r="3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle
			cx="18"
			cy="12"
			r="3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<line
			x1="9"
			y1="12"
			x2="9"
			y2="12"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="15"
			y1="12"
			x2="15"
			y2="12"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component switcher(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="1"
			y="8"
			width="22"
			height="8"
			rx="4"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="18" cy="12" r="3" fill="currentColor" />
	</svg>
}

export component tabs(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect x="3" y="7" width="5" height="3" rx="1" fill="currentColor" />
		<rect
			x="8"
			y="7"
			width="5"
			height="3"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="13"
			y="7"
			width="5"
			height="3"
			rx="1"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="3"
			y="10"
			width="18"
			height="8"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component tags(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<path
			d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<line
			x1="7"
			y1="7"
			x2="7.01"
			y2="7"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component timer(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="13"
			r="8"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path
			d="M12 9l0 4l3 3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M9 4h6" stroke="currentColor" strokeWidth="2" />
		<path d="M12 2v2" stroke="currentColor" strokeWidth="2" />
	</svg>
}

export component toast(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="2"
			y="6"
			width="20"
			height="12"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="8" cy="12" r="2" fill="currentColor" />
		<line
			x1="12"
			y1="10"
			x2="18"
			y2="10"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="12"
			y1="14"
			x2="16"
			y2="14"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component toggle(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect x="3" y="8" width="5" height="8" rx="2" fill="currentColor" />
		<rect
			x="8"
			y="8"
			width="5"
			height="8"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<rect
			x="13"
			y="8"
			width="5"
			height="8"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
	</svg>
}

export component tooltip(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="2"
			y="3"
			width="20"
			height="14"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<path d="M12 17l-3-3h6l-3 3z" fill="currentColor" />
	</svg>
}

export component tour(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="12"
			cy="12"
			r="10"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="12" cy="12" r="3" fill="currentColor" />
		<path
			d="M12 1v6m0 6v6m11-7h-6m-6 0H1"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</svg>
}

export component tree(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<circle
			cx="6"
			cy="6"
			r="3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle
			cx="6"
			cy="18"
			r="3"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="20" cy="12" r="3" fill="currentColor" />
		<path d="M9 12h8.5" stroke="currentColor" strokeWidth="2" />
		<path d="M9 6v12" stroke="currentColor" strokeWidth="2" />
	</svg>
}

// Default fallback icon
export component defaultIcon(props) {
	<svg viewBox="0 0 24 24" {...props}>
		<rect
			x="4"
			y="4"
			width="16"
			height="16"
			rx="2"
			stroke="currentColor"
			strokeWidth="2"
			fill="none"
		/>
		<circle cx="12" cy="12" r="2" fill="currentColor" />
	</svg>
}
